import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class CredistScene extends MinigameScene {
    //Images

    //values

    //logic vars

    constructor(){
        super ({
            sceneName: CONST.SCENES.CREDITS,
            duration: 5000,
            startScreenColor: 0xC1FFDB,
            startText: "",
            startTextColor: 0x323232,
            nextScene: CONST.SCENES.MENU,
            timeToStart: 0,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 386, scale: 1.30},
                normalWithSkip: {x: 283, y: 386, scale: 1.30},
                skip: {x: 570, y: 386, scale: 1.30}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
    }

    _preload(){
    }

    _create(){
        this.add.image(0, 0, CONST.CREDITS.END).setOrigin(0,0);
    }

    _update(time: number, delta: number){
    }

    _timeout(){
        this.winGame();
    }

    _afterLoss(){
    }

    _afterWin(){
    }
}
